// extracted by css-extract-rspack-plugin
export default {"accordion":"JYBWK47zFwKPulqd","target":"KL2y8CWitc5aThVe","targetIcon":"uqEEPWjbV2oy43Rs","targetIconIsOpen":"NxTzM8j4SoF1hL5m","body":"I7HwP8oPS2MQgSwx"};